export enum ProductFamilyEnum {
  financialProduct = 'financialProduct',
  servicePlan = 'servicePlan',
  operatingLease = 'operatingLease',
  privateLease = 'privateLease',
}

export interface ProductFamilySelectionFormStateModel {
  productFamily: ProductFamilyEnum | null;
}
